import { camelize } from '../../../../organization-applications-settings-form/form'
import { languageInfo, LanguageInfo } from './constants'

// url utils
export const getOrgUuid = (): string => location.hash.split('/')?.at(1) || ''
export const getCurrentLanguage = (): string =>
  location.hash.split('/')?.at(4) || ''
export const setCurrentLanguage = (language) => {
  location.hash = location.hash.replace(
    `/${getCurrentLanguage()}`,
    `/${language}`
  )
}

// language utils
export const getLanguageInfo = (language): LanguageInfo | undefined =>
  languageInfo.find((it) => it.type === language)

// metadata utils
export const metadataDisplayToAgentLabel = (it) => camelize(it)

// general
export const nullFn = () => null // this is nonsense just to satisfy sonar/ts
export const identity = (it) => it
export const identityOrValue = (value) => (it) => it || value
export const identityOrEmptyString = identityOrValue('')
export const sortByProperty = (prop) => (a, b) => b[prop] - a[prop]
